import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  :root {
    --dark-orange: #e95011ff;
    --light-orange: #f39016ff;
    /*--dark-grey: #242424ff;*/
    --dark-grey: #111111;
    --dark-grey-70: #242424b3;
    --green: #00a878ff;
    --error: #ff4b4b;
  }

* {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    body {
      background-color: #fafbfc;
      color: #fff;
      -webkit-font-smoothing: antialiased;
    }
    body, input, button {
      font-size: 14px;
      font-family: 'Roboto', sans-serif;
    }
    a {
      text-decoration: none;
    }
    ul {
      list-style: none;
    }
    button {
      cursor: pointer;
    }
  }

  .table--striped {
  .ant-table-row:nth-child(even) {
    background-color: #f5f5f5;
    td.ant-table-cell-fix-left {
      background-color: #f5f5f5;
    }
    &:hover td.ant-table-cell-fix-left {
      background: #fafafa;
    }
  }

  .ant-table {
    font-size: 12px;
    line-height: 18px;
  }
}
  `;
